import { Flex } from '@servicetitan/anvil2';
import { LoadingScreen } from '@servicetitan/financing-utils-shared';
import { useLoanSubmission } from './hooks/useLoanSubmission';
import { WorkflowStore } from '@servicetitan/financing-workflow-shared';

export const SubmitLoan = () => {
    const { setWorkflowStage } = WorkflowStore.useStore();

    useLoanSubmission({
        autoSubmit: true,
        onSuccess: () => {
            setWorkflowStage('decision');
        },
    });

    return (
        <Flex direction="column" gap="6" alignItems="center" style={{ margin: '240px auto' }}>
            <LoadingScreen message="Processing your application..." />
        </Flex>
    );
};
